import { render, staticRenderFns } from "./PaymentListAddNew.vue?vue&type=template&id=70e87492"
import script from "./PaymentListAddNew.vue?vue&type=script&lang=js"
export * from "./PaymentListAddNew.vue?vue&type=script&lang=js"
import style0 from "./PaymentListAddNew.vue?vue&type=style&index=0&id=70e87492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports